<template>
    <div>
        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-calendar-alt"></i>
            </template>
            <template slot="title">Receipt Date</template>
            <template slot="sub-title">{{formatDate(expense.date, 'D MMM YYYY')}}</template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-money-bill"></i>
            </template>
            <template slot="title">Amount</template>
            <template slot="sub-title">
                {{expense.amount.join('.')}}
                {{expense.currency}}
            </template>
        </list-item>

        <list-item v-if="expense.domestic">
            <template slot="icon">
                <i class="text-blue far fa-percent"></i>
            </template>
            <template slot="title">VAT</template>
            <template slot="sub-title">
                {{expense.vat.join('.')}}
                {{expense.currency}}
            </template>
        </list-item>
    </div>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
    mixins: [InteractsWithDates],
    props: ['expense'],
}
</script>
